/**
 * router/routes/platform.routes.ts
 * Platform-shell-nested routes (SECOND AppShell parent, design §3) — the
 * platform operator's own company/role/user management + service templates,
 * plus its own catch-all. meta.platformMode:true tells AppShell to skip
 * loadMe() (PR-B guardrail).
 * Split out of router/index.ts (openspec/arquitectura/convencion-modulo.md §4).
 */
import type { RouteRecordRaw } from 'vue-router';

export const platformRoutes: RouteRecordRaw[] = [
  { path: '', redirect: { name: 'platform-companies' } },

  {
    path: 'companies',
    name: 'platform-companies',
    // PR-B stub — full PlatformCompaniesView lands in PR-C (T12).
    component: () => import('../../views/platform/PlatformCompaniesView.vue'),
  },

  // platform-company-hub: one hub per company, each tab its own URL. The old
  // /companies/:id/users and /roles URLs ARE the Users/Roles tabs (names kept);
  // the bare /companies/:id (old 'platform-company-detail') redirects to Resumen.
  {
    path: 'companies/:id',
    component: () => import('../../views/platform/CompanyHubView.vue'),
    props: true,
    children: [
      {
        path: '',
        name: 'platform-company-detail',
        redirect: (to) => ({ name: 'platform-company-summary', params: to.params }),
      },
      {
        path: 'summary',
        name: 'platform-company-summary',
        component: () => import('../../views/platform/CompanySummaryView.vue'),
        props: true,
      },
      {
        path: 'modules',
        name: 'platform-company-modules',
        component: () => import('../../views/platform/CompanyModulesView.vue'),
        props: true,
      },
      // Kernel AI credits (2026-10-12): wallet terms + month consumption.
      {
        path: 'ai',
        name: 'platform-company-ai',
        component: () => import('../../views/platform/CompanyAiView.vue'),
        props: true,
      },
      // PC-12.1: user management (add-user-mgmt-per-user-access).
      {
        path: 'users',
        name: 'platform-company-users',
        component: () => import('../../views/platform/CompanyUsersView.vue'),
        props: true,
      },
      // PC-9.1: role management (add-capability-catalog-role-mgmt).
      {
        path: 'roles',
        name: 'platform-company-roles',
        component: () => import('../../views/platform/CompanyRolesView.vue'),
        props: true,
      },
    ],
  },

  // Kernel AI credits (2026-10-12): every company's month consumption, for billing.
  {
    path: 'ai-usage',
    name: 'platform-ai-usage',
    component: () => import('../../views/platform/PlatformAiUsageView.vue'),
  },

  // add-locx-service-templates: catalog list + "asociar empresa" (instantiate).
  {
    path: 'service-templates',
    name: 'platform-service-templates',
    component: () => import('../../views/platform/ServiceTemplatesView.vue'),
  },

  { path: ':pathMatch(.*)*', redirect: { name: 'platform-companies' } },
];
